import { createMemo } from "solid-js"

interface HrProps {
	glyph: "asterisk" | "slash" | "dot"
	fill?: string
}

export default function Hr(props: HrProps) {
	let backgroundImage = ""
	const resolvedColor = getComputedStyle(document.documentElement).getPropertyValue(`--color-${props.fill}`)

	switch (props.glyph) {
		case "asterisk":
			backgroundImage = asteriskLine({ fill: resolvedColor })
			break
		case "dot":
			backgroundImage = dotLine({ fill: resolvedColor })
			break
		case "slash":
			backgroundImage = slashLine({ fill: resolvedColor })
			break
		default:
			throw new Error(`Unknown glyph: ${props.glyph}`)
	}

	const dataUri = `url("data:image/svg+xml,${backgroundImage}")`
	return (
		<span class="text-base-content">
			<hr style={{ "background-image": dataUri }} class="h-4 bg-repeat-x bg-left border-0 flex-shrink-0 text-base-content" />
		</span>
	)
}

function asteriskLine(props: { fill: string }): string {
	const fillColor = props.fill || "currentColor"
	const encoded = createMemo(() => {
		return encodeURIComponent(`
			<svg width="22" height="22" viewBox="0 0 9 22" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M0 12.2339L1.75 11.2576V10.7424L0 9.7661L0.888889 8.22034L2.63889 9.22373L3.08333 8.95254V7H4.88889V8.95254L5.33333 9.22373L7.08333 8.22034L8 9.7661L6.25 10.7424V11.2576L8 12.2339L7.08333 13.7525L5.33333 12.7763L4.88889 13.0203V15H3.08333V13.0203L2.63889 12.7763L0.888889 13.7525L0 12.2339Z" fill="${fillColor}"/>
			</svg>
		`)
	})

	return encoded()
}

function dotLine(props: { fill: string }): string {
	const fillColor = props.fill || "currentColor"
	const encoded = createMemo(() => {
		return encodeURIComponent(`
			<svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M0 2.14224L0.699281 1.74265V1.53176L0 1.13217L0.35519 0.499487L1.05447 0.910175L1.23207 0.799179V0H1.95355V0.799179L2.13114 0.910175L2.83042 0.499487L3.19671 1.13217L2.49743 1.53176V1.74265L3.19671 2.14224L2.83042 2.76382L2.13114 2.36424L1.95355 2.46413V3.27441H1.23207V2.46413L1.05447 2.36424L0.35519 2.76382L0 2.14224Z" fill="${fillColor}"/>
			</svg>
		`)
	})

	return encoded()
}

function slashLine(props: { fill: string }): string {
	const fillColor = props.fill || "currentColor"
	const encoded = createMemo(() => {
		return encodeURIComponent(`
			<svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M4.83375 2.35209V0.492615H5.98832V2.82607L1.67386 7.14053V9H0.519287V6.66655L4.83375 2.35209Z" fill="${fillColor}"/>
			</svg>
		`)
	})

	return encoded()
}
